package com.iregained.site.components.sections.distributors.sections

import androidx.compose.runtime.*
import com.iregained.site.components.sections.home.styles.InvertedPrimaryButtonStyle
import com.iregained.site.components.widgets.SharedCtaActionLink
import com.iregained.site.components.widgets.SharedCtaWidget
import com.varabyte.kobweb.browser.dom.observers.IntersectionObserver
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionTimingFunction
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.deg
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.s
import org.jetbrains.compose.web.dom.Div

// UNIQUE ANIMATION: 3D Card Flip-Up
@Composable
private fun Modifier.cardFlipUp(isVisible: Boolean): Modifier {
    return this.opacity(if (isVisible) 1 else 0).rotateX(if (isVisible) 0.deg else 45.deg)
        .translateY(if (isVisible) 0.px else 40.px)
        .styleModifier { property("transform-origin", "bottom center"); property("perspective", "1000px") }.transition(
            Transition.of("opacity", 0.8.s, TransitionTimingFunction.EaseOut),
            Transition.of("transform", 0.8.s, TransitionTimingFunction.EaseOut)
        )
}

@Composable
fun DistributorsCtaSection(data: DistributorLocatorData = defaultDistributorData) {
    var isVisible by remember { mutableStateOf(false) }

    if (data.ctaHeadline.isNotBlank()) {
        Div(
            attrs = Modifier.fillMaxWidth().id(data.ctaSectionId ?: "distributors-cta-section")
            .styleModifier { property("scroll-margin-top", "100px") }
            .toAttrs {
                ref { element ->
                    val observer = IntersectionObserver { entries, obs ->
                        entries.forEach {
                            if (it.isIntersecting) {
                                isVisible = true; obs.unobserve(element)
                            }
                        }
                    }
                    observer.observe(element)
                    onDispose { observer.disconnect() }
                }
            }) {
            Box(
                modifier = Modifier.fillMaxWidth().cardFlipUp(isVisible)
            ) {
                SharedCtaWidget(
                    headline = data.ctaHeadline, description = data.ctaDescription, actions = {
                        if (data.ctaButtonText.isNotBlank() && data.ctaLink.isNotBlank()) {
                            SharedCtaActionLink(
                                text = data.ctaButtonText,
                                path = data.ctaLink,
                                styleModifier = InvertedPrimaryButtonStyle.toModifier()
                            )
                        }
                    })
            }
        }
    }
}